import { render, staticRenderFns } from "./EditRRuleModal.vue?vue&type=template&id=6ad4eb8a"
import script from "./EditRRuleModal.vue?vue&type=script&lang=js"
export * from "./EditRRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports